import { Image, Typography } from '@iheartjane/reefer';
import type { Nullish } from '@iheartjane/types';
import { clsx } from 'clsx';
import compact from 'lodash-es/compact';

import styles from './brandLogo.module.css';

interface BrandLogoProps {
  logo_url: Nullish<string>;
  name: string;
  smHeight?: boolean;
}

const getBrandInitials = (name: string) => {
  // remove all characters that aren't whitespace or alphanumeric
  // to avoid "F-" for instance with "Foo - BR" & get "FB" instead.
  const cleanName = name.replace(/[^\s\w\d]/g, '');

  return compact(cleanName.split(/\s+/g).map((x) => x[0]))
    .slice(0, 2)
    .join('')
    .toUpperCase();
};

export function BrandLogo({
  logo_url,
  name,
  smHeight = false,
}: BrandLogoProps) {
  const label = logo_url ? `Logo for ${name}` : `Brand initials for ${name}`;
  const brandInitials = getBrandInitials(name);

  return !logo_url ? (
    <div
      aria-label={label}
      className={clsx(styles['brandLogo'], {
        [styles['brandLogo__mdHeight']]: !smHeight,
        [styles['brandLogo__smHeight']]: smHeight,
      })}
      role="img"
    >
      <Typography variant="body-semibold">{brandInitials}</Typography>
    </div>
  ) : (
    <Image
      altText={label}
      src={logo_url}
      className={clsx(styles['brandLogoImage'], {
        [styles['brandLogoImage__mdHeight']]: !smHeight,
      })}
      border
      objectPosition="50% 50%"
      objectFit="contain"
    />
  );
}
